import React, { useState,useEffect } from "react";
import { Grid } from "@material-ui/core";

import WordCards from "../wordcards/WordCards";
import Typecards from "../typecards/Typecards";
import Searchbar from "../searchbar/Searchbar";

import useStyles from "./style";

const Worddict = () => {
  const classes = useStyles();

  const [word, setWord] = useState("");
  const [type, setType] = useState("definitions");
  const [finalWord, setFinalWord] = useState("");

  useEffect(() => {
    setFinalWord("");
  }, [type, word]);

  return (
    <>
      <Grid container className={classes.container}>
        <Grid item xs={12} md={5}>
          <Searchbar
            word={word}
            setWord={setWord}
            type={type}
            setType={setType}
            finalWord={finalWord}
            setFinalWord={setFinalWord}
          />
        </Grid>
        <Grid item xs={12} md={7}>
          {finalWord != "" ? (
            type == "everthing" ? (
              <WordCards word={finalWord} />
            ) : (
              <Typecards
                word={finalWord}
                type={type}
              />
            )
          ) : (
            <></>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default Worddict;
